import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prefer-const */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DiskIcon } from '../components/assets/DiskIcon';
import { FilterChipBarCollapsible } from './FilterChipBarCollapsible';
import { IsMobileView } from './isMobileView';
import { StyledButton } from '../components/assets/StyledButton';
import { StyledIconButton } from '../components/assets/StyledIconButton';
import { StyledLabel } from '../components/assets/StyledLabel';
// import VerticalDotsIcon from '../components/assets/VerticalDotsIcon';
import { useLocalStorage } from '../utils';
import { SelectComponent } from './SelectComponent';
import { TrashIcon } from '../components/assets/TrashIcon';
// import { PencilIcon } from '../components/assets/PencilIcon';
import SuccessToast from '../components/SuccessToast';
import ErrorToast from '../components/ErrorToast';
import VerticalDotsIcon from '../components/assets/VerticalDotsIcon';
import { PencilIcon } from '../components/assets/PencilIcon';
const useStyles = makeStyles(createStyles({
    columnsPopOver: {
        padding: 24,
        display: 'flex',
    },
    FiltersCss: {
        border: '1px solid rgba(224, 224, 224, 1)',
    },
    filtersResetButton: {
        position: 'absolute',
        top: 18,
        right: 21,
    },
    popoverTitle: {
        fontWeight: 500,
        padding: '0 24px 24px 0',
        textTransform: 'uppercase',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 218px)',
        '@media (max-width: 600px)': {
            gridTemplateColumns: 'repeat(1, 180px)',
        },
        gridColumnGap: 24,
        gridRowGap: 24,
    },
    cell: {
        display: 'flex',
        flexDirection: 'column',
    },
    hidden: {
        display: 'none',
    },
}));
export function FilterPageCustom({ instance, onClose, filterActive, setLocalFilterActive, tableName, customFilterJsx, allFiltersCustom, }) {
    const { t } = useTranslation();
    const classes = useStyles({});
    const isMobile = IsMobileView();
    const { allColumns, setAllFilters } = instance;
    const heightRef = React.useRef(null);
    // eslint-disable-next-line
    const [showMore, setShowMore] = React.useState(() => false);
    const [filterNameIsUpdated, setFilterNameIsUpdated] = React.useState(false);
    const [canSaveUpdated, setCanSaveUpdated] = React.useState(true);
    const [nameIsUpdated, setNameIsUpdated] = React.useState('');
    // eslint-disable-next-line
    const [currentHeight, setCurrentHeight] = React.useState(() => 120);
    // for adding  selected filter
    const [savedFilters, setSavedFilters] = useLocalStorage(`${tableName}_SavedFilters`, []);
    const [designationFilter, setDesignationFilter] = React.useState('');
    // eslint-disable-next-line
    const [oldFilterName, setOldFilterName] = React.useState('');
    const handleSaveFiltersClick = React.useCallback(() => {
        const found = savedFilters.find((f) => f.label === designationFilter);
        if (filterNameIsUpdated || found) {
            if ((nameIsUpdated === null ||
                nameIsUpdated === undefined ||
                nameIsUpdated === '') &&
                (designationFilter === null ||
                    designationFilter === undefined ||
                    designationFilter === '')) {
                ErrorToast(t('Please enter a designation for your filter.'));
                return;
            }
            if (Object.keys(instance.state.filters).length === 0) {
                ErrorToast(t('Please choose at least one filter'));
                return;
            }
            if (canSaveUpdated === false) {
                return;
            }
            if (Object.keys(instance.state.filters).length > 0) {
                const found = savedFilters.find((f) => f.label === designationFilter);
                if (found) {
                    let flt = savedFilters;
                    flt[flt.findIndex((f) => f.label === designationFilter)] = {
                        label: ['', null, undefined].indexOf(nameIsUpdated) === -1
                            ? nameIsUpdated
                            : designationFilter,
                        value: instance.state.filters,
                    };
                    setSavedFilters(allFiltersCustom ? allFiltersCustom : flt);
                    setNameIsUpdated('');
                    setDesignationFilter('');
                    SuccessToast(t('Filter successfully updated'));
                }
            }
        }
        else {
            if (designationFilter === null ||
                designationFilter === undefined ||
                designationFilter === '') {
                ErrorToast(t('Please enter a designation for your filter.'));
                return;
            }
            if (Object.keys(instance.state.filters).length === 0) {
                ErrorToast(t('Please choose at least one filter'));
                return;
            }
            if (Object.keys(instance.state.filters).length > 0) {
                setSavedFilters(allFiltersCustom
                    ? allFiltersCustom
                    : [
                        ...savedFilters,
                        { label: designationFilter, value: instance.state.filters },
                    ]);
                SuccessToast(t('Filter successfully added'));
                setFilterNameIsUpdated(false);
                // found ? SuccessToast(t('Filter successfully added')) : SuccessToast(t('Filter successfully added'));
            }
        }
        setFilterNameIsUpdated(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        designationFilter,
        instance.state.filters,
        setSavedFilters,
        savedFilters,
        nameIsUpdated,
    ]);
    const handleModifyFilter = React.useCallback(() => {
        if (designationFilter === '') {
            ErrorToast(t('Please choose at least one filter'));
        }
        else {
            setNameIsUpdated(designationFilter);
            setFilterNameIsUpdated(true);
        }
    }, [savedFilters, oldFilterName]);
    const handleSavedFiltersSelect = React.useCallback((selectedValue) => {
        if (selectedValue) {
            setDesignationFilter(selectedValue.label);
            const indexofSelected = savedFilters.findIndex((f) => f.label === selectedValue.label);
            indexofSelected > -1
                ? (function () {
                    setAllFilters(savedFilters[indexofSelected].value);
                    setOldFilterName(selectedValue.label);
                })()
                : setAllFilters([]);
        }
    }, [savedFilters, setAllFilters]);
    function handleDeleteFilter() {
        if (designationFilter === null ||
            designationFilter === undefined ||
            designationFilter === '') {
            ErrorToast(t('Please select a filter for deletion'));
            return;
        }
        const found = savedFilters.find((f) => f.label === designationFilter);
        if (found) {
            savedFilters.splice(savedFilters.findIndex((f) => f.label === designationFilter), 1);
            setSavedFilters(allFiltersCustom ? allFiltersCustom : savedFilters);
            setAllFilters([]);
            setDesignationFilter('');
            SuccessToast(t('Filter successfully removed'));
        }
    }
    React.useEffect(() => {
        if (heightRef.current !== null) {
            setShowMore(document.getElementById('FilterChipBar').offsetHeight > 120);
            setCurrentHeight(document.getElementById('FilterChipBar').offsetHeight);
        }
    }, [designationFilter, instance.state.filters]);
    return (_jsxs("div", Object.assign({ className: (classes.columnsPopOver, classes.grid, classes.cell), style: { marginLeft: 5, marginRight: 5 } }, { children: [_jsx(StyledLabel, Object.assign({ style: {
                    borderBottom: '2px solid',
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 10,
                } }, { children: t('Saved filters') })), _jsx(Box, Object.assign({ component: "div", sx: { display: 'flex', justifyContent: 'space-between' } }, { children: _jsx("div", Object.assign({ style: { width: ' 100%', marginTop: 10, marginBottom: '5px' } }, { children: _jsxs("div", Object.assign({ style: {
                            display: 'grid',
                            gridTemplateColumns: '10fr 1fr',
                            alignItems: 'center',
                        } }, { children: [_jsx(SelectComponent, { options: savedFilters.length > 0 ? savedFilters : [], setDesignationFilter: setDesignationFilter, handleSavedFiltersSelect: handleSavedFiltersSelect, designationFilter: designationFilter, setAllFilters: setAllFilters, filterNameIsUpdated: filterNameIsUpdated, nameIsUpdated: nameIsUpdated, setNameIsUpdated: setNameIsUpdated, savedFilters: savedFilters, setCanSaveUpdated: setCanSaveUpdated, canSaveUpdated: canSaveUpdated, placeholder: `${t('Select')} / ${t('Add')}` }), _jsxs(Box, Object.assign({ component: "div", sx: { display: 'flex', alignItems: 'end' } }, { children: [_jsx(StyledIconButton, Object.assign({ icon: "DiskIcon", style: {
                                            margin: '0px 5px',
                                            border: '1px solid',
                                            borderRadius: '6px',
                                        }, onClick: handleSaveFiltersClick }, { children: _jsx(DiskIcon, { height: 20, width: 20 }) })), _jsxs(StyledIconButton, Object.assign({ icon: "VerticalDotsIcon", style: {
                                            margin: '0px 5px',
                                            border: '1px solid',
                                            borderRadius: '6px',
                                        } }, { children: [_jsx(VerticalDotsIcon, { height: 20, width: 20, className: "dropdown", id: "filteraction", "data-bs-toggle": "dropdown" }), _jsxs("div", Object.assign({ className: "dropdown-menu", "aria-labelledby": "dropdownMenuButton" }, { children: [_jsxs("div", Object.assign({ className: `dropdown-item d-flex align-items-center `, onClick: () => {
                                                            handleModifyFilter();
                                                        } }, { children: [_jsx(PencilIcon, { className: 'mx-2 ', style: { cursor: 'pointer' }, height: 20, width: 20, onClick: () => { } }), t('Modify')] })), _jsxs("div", Object.assign({ className: "dropdown-item d-flex align-items-center", onClick: handleDeleteFilter }, { children: [_jsx(TrashIcon, { style: { cursor: 'pointer' }, height: 20, width: 20, onClick: () => { }, className: "mx-2" }), t('Delete')] }))] }))] }))] }))] })) })) })), _jsx(StyledLabel, Object.assign({ style: {
                    borderBottom: '2px solid',
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 10,
                } }, { children: t('Filter') })), Object.keys(instance.state.filters).length > 0 ? (_jsx(Box, Object.assign({ id: "FilterChipBar", component: "div", ref: heightRef }, { children: _jsx(FilterChipBarCollapsible, { instance: instance, showMore: showMore, currentHeight: currentHeight, setDesignationFilter: setDesignationFilter }) }))) : (_jsx(StyledButton, Object.assign({ rounded: true, variant: "light", style: { width: '100%', color: '#000' } }, { children: t('No active filter') }))), customFilterJsx !== undefined ? (customFilterJsx) : (_jsx(Box, Object.assign({ component: "div", id: "listfilter", style: {
                    maxHeight: !isMobile ? 'calc(100vh - 350px)' : 'auto',
                    overflow: 'auto',
                    alignItems: 'center',
                } }, { children: allColumns
                    .filter((it) => it.canFilter &&
                    it.isVisible &&
                    it.id !== '_selector' &&
                    it.id !== 'delete' &&
                    it.id !== '_Actions' &&
                    it.id !== 'expander' &&
                    it.id !== 'hidecolumns')
                    .map((column) => (_jsx("div", Object.assign({ className: "my-2" }, { children: column.render('Filter') }), column.id))) })))] })));
}
//# sourceMappingURL=FilterPageCustom.js.map